export default {"id":"5f0570bf","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}